/**
 * CARGO E LOTAÇÃO EM LISTAS (spec 0072, KD-9) — o que as telas de Contas e do
 * Perfil dividem.
 *
 * O valor de cada lista é o id do catálogo de cargos e do setor da entidade, e
 * não o nome: gravar a lotação pelo nome criaria setor quando o nome não batesse.
 * Lista esvaziada limpa o cargo. A lotação é obrigatória e não se esvazia
 * (spec 0092): não há mais setor principal para onde voltar.
 */

import type { CargoNaTela, Opcao, SetorNaTela } from "../api"
import type { CampoDoBloco, ValoresDoBloco } from "../componentes/BlocoDeCampos"

export function opcoesDosCargos(cargos: CargoNaTela[]): Opcao[] {
  return cargos.map((c) => ({ chave: String(c.id), rotulo: c.nome }))
}

export function opcoesDosSetores(setores: SetorNaTela[]): Opcao[] {
  return setores.map((s) => ({ chave: String(s.id), rotulo: s.caminho }))
}

/** Troca os campos de texto `cargo` e `lotacao` pelas listas. */
export function comListasDoVinculo(campos: CampoDoBloco[], cargos: Opcao[], setores: Opcao[]): CampoDoBloco[] {
  return campos.map((campo) =>
    campo.campo === "cargo"
      ? { campo: "cargo_id", rotulo: campo.rotulo, tipo: "escolha", opcoes: cargos }
      : campo.campo === "lotacao"
        ? { campo: "setor_id", rotulo: campo.rotulo, tipo: "escolha", opcoes: setores, obrigatorio: true }
        : campo,
  )
}

/** Os valores da tela, com os ids do vínculo como texto, para as listas. */
export function valoresComIds(dados: { cargo_id: number | null; setor_id: number | null }): ValoresDoBloco {
  return {
    ...(dados as unknown as ValoresDoBloco),
    cargo_id: dados.cargo_id === null ? "" : String(dados.cargo_id),
    setor_id: dados.setor_id === null ? "" : String(dados.setor_id),
  }
}

/** A mudança da tela no formato da API: ids viram número. */
export function pedidoDoVinculo(mudanca: Record<string, string | null>): Record<string, string | number | null> {
  const pedido: Record<string, string | number | null> = {}
  for (const [campo, valor] of Object.entries(mudanca)) {
    if (campo === "cargo_id") {
      if (valor) pedido["cargo_id"] = Number(valor)
      else pedido["cargo"] = null
    } else if (campo === "setor_id") {
      if (valor) pedido["setor_id"] = Number(valor)
      else pedido["lotacao"] = null
    } else {
      pedido[campo] = valor
    }
  }
  return pedido
}
